module.exports = __webpack_public_path__ + "img/icon-calendar-grey.5fe7206f.svg";